import apis from "@/config/apis";
import { routerPush } from "@/config/locationRouter";
import { localDB } from "@/config/storage";
import store from "@/store";

export default {
  methods: {
    async checkoutLogin(cb, path) {
      try {
        const resp = await apis.user.tokenUpdate();
        if (resp.success === "no") {
          localDB.removeItem("TOKEN_TIME");
          localDB.removeItem("TOKEN");
          localDB.removeItem("USER_INFO");
          if (path) {
            routerPush({ path: "login", query: { target: path } });
          }
        } else if (resp.success === "ok") {
          if (resp.token) {
            store.state.commit("user/SET_TOKEN", resp.token);
            localDB.setItem("user/TOKEN", resp.token);
            cb();
          } else {
            cb();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
